"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagService = void 0;
var tslib_1 = require("tslib");
var store_1 = require("../store");
var index_1 = require("./index");
var TagService = /** @class */ (function () {
    function TagService() {
        this.__priority = 100;
    }
    TagService.prototype.refresh = function (tagIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var promises, _i, tagIds_1, tagId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, store_1.AppStore.Tag.refresh()];
                    case 1:
                        _a.sent();
                        promises = [];
                        for (_i = 0, tagIds_1 = tagIds; _i < tagIds_1.length; _i++) {
                            tagId = tagIds_1[_i];
                            promises.push(store_1.AppStore.TagSummary.getFetchable(tagId).refetch());
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, index_1.Services.Search.search()];
                }
            });
        });
    };
    TagService.prototype.rename = function (tagId, newName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest, tag, newTagJson;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rest = index_1.Services.Department.rest;
                        tag = store_1.AppStore.Tag.get(tagId);
                        tag.name = newName;
                        return [4 /*yield*/, rest.save(rest.Objects.Tag, tag)];
                    case 1:
                        newTagJson = _a.sent();
                        return [4 /*yield*/, this.refresh([newTagJson.objectId])];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, newTagJson];
                }
            });
        });
    };
    return TagService;
}());
exports.TagService = TagService;
//# sourceMappingURL=tag.service.js.map